export const HTTP_204_NO_CONTENT = 204
